import { makeStyles } from '@fluentui/react-components';

export const useAuthGuardStyles = makeStyles({
  spinnerContainer: {
    display: 'flex',
    height: '100vh',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'var(--colorNeutralBackground1)',
  },
});
